var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title-text":("" + (_vm.$t('forgotPassword_title'))),"text":("" + (_vm.$t('forgotPassword_title_text'))),"data-qa":"por-forgot--title"}}),_c('ForgotPasswordForm',{attrs:{"data-qa":"por-forgot--form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }